import requestAction from '../../utils/requestAction'
import { Dispatch } from 'react'
import { initialApiState, ApiAction } from '../../utils/requestAction';

const makeRequest = requestAction('SESSION')

export const fetchSession = (history, location, title) =>
  makeRequest('session', 'GET', undefined, undefined, undefined,
    handleResponse(location, history, title), 
    handleError(history)
  )

const handleResponse = (location, history, title) => (dispatch: Dispatch<ApiAction>, getState, response) => {
  if (response && location.pathname === '/') {
    if (response.roles.includes('administrator')) {
      history.push('/admin/dashboard', { title: title })
      return
    }
    if (response.roles.includes('client')) {
      history.push('/client/dashboard', { title: title })
      return
    }
    if (response.roles.includes('vendor')) {
      history.push('/vendor/dashboard', { title: title })
      return
    }
    if (response.roles.includes('staff')) {
      history.push('/staff/dashboard', { title: title })
      return
    }
    if (response.roles.includes('headsales')) {
      history.push('/headsales/dashboard', { title: title })
      return
    }
    if (response.roles.includes('manager')) {
      history.push('/manager/dashboard', { title: title })
      return
    }
    doLogout(history)(dispatch)
  }

}

const handleError = history => (dispatch: Dispatch<ApiAction>, err: Error) => {
  doLogout(history)(dispatch)
}

export const doLogout = history => (dispatch: Dispatch<ApiAction>) => {
  window.localStorage.removeItem('token')
  dispatch({
    type: 'SESSION_CLOSED', 
    newApiState: initialApiState
  })
  history.push('/login')
}


export const tokenExpired = () => ({
  type: 'TOKEN_EXPIRED',
})

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return true; // Token viejo: forzamos logout
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
  } catch {
    return true;
  }
}
